import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Person from "./person";

// /management/:id stays — it's the Person deep page (perf reviews, objectives, etc.).
// /management and /management/overview/:id now redirect to the merged People page.

const Management = () => {
  return (
    <Routes>
      <Route path="/overview/:id" element={<Navigate to="/people" replace />} />
      <Route path="/:id" element={<Person />} />
      <Route path="/" element={<Navigate to="/people" replace />} />
    </Routes>
  );
};

export default Management;
